module.exports = __webpack_public_path__ + "static/media/mrc_4_gif.f7cba1b9.gif";